// extracted by mini-css-extract-plugin
export default {"component":"style_component__cB9sm","content":"style_content__1PbJ+","bg_main":"style_bg_main__mQwJN","bg_top":"style_bg_top__bOaaB"};